import script from "./StubsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./StubsBlock.vue?vue&type=script&setup=true&lang=js"

import "./StubsBlock.vue?vue&type=style&index=0&id=2376629a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2376629a"]])

export default __exports__